module.exports = __webpack_public_path__ + "static/img/4.2d670038.webp";